import React, { useState } from 'react';
import { Close } from '@material-ui/icons';

import ConfigData from '../config.json';
import Gallery from '../components/Gallery';

const FlatIllustration = () => {
    const [modal, setModal] = useState(false);
    const [imageSource, setImageSource] = useState('');
    const [imageAlt, setImageAlt] = useState('');
    const openImage = (imagePath, imageAlt) => {
        setImageSource(imagePath);
        setImageAlt(imageAlt);
        setModal(true);
    };
    const closeImage = () => {
        setModal(false);
    };
    return (
        <Gallery>
            <div className={'gallery'}>
                {
                    ConfigData.gallery.flatIllustration.map(data => (
                        <div className={'pics'} key={data.id} onClick={() => openImage(data.image, data.alt)}>
                            <img src={data.image} alt={data.alt} style={{ width: '100%' }} />
                        </div>
                    ))
                }
            </div>
            <div className={modal ? 'modal open' : 'modal'}>
                <img src={imageSource} alt={imageAlt} />
                <Close onClick={() => closeImage()} />
            </div>
        </Gallery>
    )
}
export default FlatIllustration;